<section #banner class="e-alert e-alert--info e-alert--global" role="note" popover="manual">
  <span class="e-alert__icon">
    <e-icon name="informationCircle" class="e-icon--color-grey" />
  </span>
  <h2 class="e-alert__title">{{ maintenance().title }}</h2>
  <div class="e-alert__text">
    <p>{{ maintenance().body }}</p>
    <p>{{ maintenance().startDate | dateRange: maintenance().endDate }}</p>
  </div>
  <button
    type="button"
    class="e-btn e-btn--icon e-btn--sm"
    aria-label="Lukk"
    (click)="dismiss.emit()">
    <span class="e-btn__icon">
      <e-icon name="closeBold" />
    </span>
  </button>
</section>
